export const GET_CUSTOMER_PREVIOUS_ORDERS = 'GET_CUSTOMER_PREVIOUS_ORDERS';
export const CUSTOMER_PREVIOUS_ORDERS_SUCCESS = 'CUSTOMER_PREVIOUS_ORDERS_SUCCESS';

export const getPreviousOrders = (customerId) => ({
  type: GET_CUSTOMER_PREVIOUS_ORDERS,
  customerId,
});

export const customerPreviousOrdersSuccess = ({ salesOrders, fulfillmentPlans, totalCount }) => ({
  type: CUSTOMER_PREVIOUS_ORDERS_SUCCESS,
  salesOrders,
  fulfillmentPlans,
  totalCount,
});
